import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import EndPointService from "../services/endpoint";

import { useAuth } from "../hooks/useAuth";

import './ProtectedRoute.scss'

export const ProtectedRoute = (props: any) => {
    const children: any = props.children
    const [appName, setAppName] = useState("-");
    const [appVersion, setAppVersion] = useState("-");
    const [checked, setChecked] = useState(false);

    const { user, logout, check } = useAuth();

    useEffect(() => {
        check().then(() => {
            setChecked(true);
        })

        EndPointService.app()
            .then(({name, version}) => {
                setAppName(name);
                setAppVersion(version);
            })
            .catch(() => {
                setAppName(`Erreur lors du chargement des informations de l'application`);
                setAppVersion('Erreur');
            })
    })

    const handleLogout = () => {
        setChecked(false);
        logout();
    };
    return (
        <div className="page">
            <div className="header">
                <div className="header-title">
                    <img className="header-logo" src="/images/logo.png" alt="McLloyd" />
                </div>
                <div className="header-logged">
                    {   checked
                        ?   <>
                                <span className="header-username">{ user }</span>
                                <button className="header-logout" onClick={() => handleLogout()}>
                                    <FontAwesomeIcon icon="sign-out-alt" />
                                </button>
                            </>
                        :   <span className="header-username"><FontAwesomeIcon icon="spinner" spin /></span> }
                </div>
                
            </div>
            <div className="container">
                {   checked ? children : <span className="checking"><FontAwesomeIcon icon="spinner" size="5x" spin /></span> }
            </div>
            <div className="footer">
                <span className="app-name">{appName}</span>
                <span className="app-version">{appVersion}</span>
            </div>
        </div>
    );
};